









































import { Component, Prop, Vue } from "vue-property-decorator";
import { IDetail, ICount } from "@/api/types";
import { Icon, Toast, Overlay, Checkbox, Field } from "vant";
import Native from "@/common/Native";
import { needToken } from "@/common/decorator";
import { isOpenInWechat } from "@/common/utils";
import request from "@/api/index";
@Component({
  components: {
    [Icon.name]: Icon
  }
})
export default class Footer extends Vue {
  @Prop()
  detail!: IDetail;

  @Prop({
    default: false
  })
  isHighPerformance?: boolean;

  @Prop()
  countJson!: ICount;

  @Prop({
    default: false
  })
  zanStatus?: boolean;

  showBarrage = true;
  showBarrageButton = true;
  get isApp() {
    return Native.isOpenInApp();
  }
  get width() {
    let normal = 0;
    if (this.isHighPerformance) {
      if (this.showBarrageButton) {
        normal = 4.68;
      } else {
        normal = 5.18;
      }
    } else {
      if (this.showBarrageButton && this.detail.isGift === 1) {
        normal = 3.7;
      } else if (!this.showBarrageButton && this.detail.isGift === 1) {
        normal = 4.2;
      } else if (this.showBarrageButton && !(this.detail.isGift === 1)) {
        normal = 4.68;
      } else if (!this.showBarrageButton && !(this.detail.isGift === 1)) {
        normal = 5.18;
      }
    }
    return normal;
  }

  get barrageButtonImg() {
    return this.showBarrage
      ? require("../assets/image/弹幕开启@2x.png")
      : require("../assets/image/弹幕关闭@2x.png");
  }

  get zanIcon() {
    if (!this.isHighPerformance) {
      if (this.detail.isPraise) {
        return require("../assets/image/已点赞@2x.png");
      } else {
        return require("../assets/image/点赞@2x.png");
      }
    } else {
      if (this.zanStatus) {
        return require("../assets/image/已点赞@2x.png");
      } else {
        return require("../assets/image/点赞@2x.png");
      }
    }
  }

  mounted() {
    if (localStorage.getItem("barrageStatus") === "false") {
      this.showBarrage = false;
    }
    this.showBarrageButton = this.detail!.isShowBulletScreen === 1;
  }

  footerShareClick() {
    this.$emit("footerShareClick");
  }
  emit(text: string) {
    this.$emit("item-click", text);
  }
  /** 点赞 */
  @needToken(true)
  zan() {
    if (!this.isHighPerformance) {
      console.log(this.detail);
      if (this.detail.isPraise) {
        return;
      } else {
        this.$emit("item-click", "zan");
      }
    } else {
      this.$emit("item-click", "zan");
    }
  }

  /** 设置弹幕 */
  setBarrage() {
    this.showBarrage = !this.showBarrage;
    this.$emit("item-click", "barrage", this.showBarrage);
    localStorage.setItem("barrageStatus", this.showBarrage + "");
  }

  /** 唤醒评论输入 */
  @needToken(true)
  inputClick() {
    if (this.detail.commentType === 0) {
      if (isOpenInWechat()) {
        this.$emit("showcommentfun", {
          sourceType: this.detail.sourceType,
          sourceId: this.$store.state.infoClassifyId,
          passiveReplyName: "",
          passiveReplyId: ""
        });
        return;
      }
      Native.openComment({
        sourceType: this.detail.sourceType,
        id: this.$store.state.infoClassifyId,
        replyId: "",
        passiveReplyName: "",
        passiveReplyId: ""
      });
    } else {
      Toast("该新闻暂不允许评论");
    }
  }
}
